import { useEffect, useState } from 'react'

import { i18n } from '@lingui/core'
import { de, en } from 'make-plural/plurals'

export const defaultLocale = 'en'

i18n.loadLocaleData({
  en: { plurals: en },
  de: { plurals: de },
})

const dynamicLoad = async (locale: string) => {
  const { messages } = await import(`./locales/${locale}/messages.ts`)
  i18n.load(locale, messages)
  i18n.activate(locale)
}

export const useLocaleHandler = (locale: string) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    dynamicLoad(locale).finally(() => setIsLoading(false))
  }, [locale])

  return isLoading
}
